"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class OrganisationMember extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'organisationMember';
        this._name = initParams.name;
        this._username = initParams.username;
        this._clients = (0, util_1.camelArray)(initParams.clients);
        this._currentlyConnected = initParams.currently_connected;
        this._orgPermission = initParams.org_permission;
        this._colour = initParams.colour;
        this.__permission = initParams._permission;
        this._profilePictureThumbnail = initParams.profile_picture_thumbnail;
        this._profilePicture = initParams.profile_picture;
        this._jobRole = initParams.job_role;
        this._alertsEnabled = initParams.alerts_enabled;
        this._lastActive = initParams.last_active;
        this._mfaEnabled = initParams.mfa_enabled;
        this._orgOverridePerms = initParams.org_override_perms;
        this._sitesLimitedTo = (0, util_1.camelArray)(initParams.sites_limited_to);
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateOrganisationMember(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set username(value) {
        console.error('Do not set objects this way');
    }
    setUsername(value) {
        return this.dataService.updateOrganisationMember(this.id, { username: value }, this);
    }
    get username() {
        return this._username;
    }
    set clients(value) {
        console.error('Do not set objects this way');
    }
    setClients(value) {
        return this.dataService.updateOrganisationMember(this.id, { clients: (0, util_1.snakeArray)(value) }, this);
    }
    get clients() {
        return this._clients;
    }
    set currentlyConnected(value) {
        console.error('Do not set objects this way');
    }
    setCurrentlyConnected(value) {
        return this.dataService.updateOrganisationMember(this.id, { currently_connected: value }, this);
    }
    get currentlyConnected() {
        return this._currentlyConnected;
    }
    set orgPermission(value) {
        console.error('Do not set objects this way');
    }
    setOrgPermission(value) {
        return this.dataService.updateOrganisationMember(this.id, { org_permission: value }, this);
    }
    get orgPermission() {
        return this._orgPermission;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    setColour(value) {
        return this.dataService.updateOrganisationMember(this.id, { colour: value }, this);
    }
    get colour() {
        return this._colour;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateOrganisationMember(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set profilePictureThumbnail(value) {
        console.error('Do not set objects this way');
    }
    setProfilePictureThumbnail(value) {
        return this.dataService.updateOrganisationMember(this.id, { profile_picture_thumbnail: value }, this);
    }
    get profilePictureThumbnail() {
        return this._profilePictureThumbnail;
    }
    set profilePicture(value) {
        console.error('Do not set objects this way');
    }
    setProfilePicture(value) {
        return this.dataService.updateOrganisationMember(this.id, { profile_picture: value }, this);
    }
    get profilePicture() {
        return this._profilePicture;
    }
    set jobRole(value) {
        console.error('Do not set objects this way');
    }
    setJobRole(value) {
        return this.dataService.updateOrganisationMember(this.id, { job_role: value }, this);
    }
    get jobRole() {
        return this._jobRole;
    }
    set alertsEnabled(value) {
        console.error('Do not set objects this way');
    }
    setAlertsEnabled(value) {
        return this.dataService.updateOrganisationMember(this.id, { alerts_enabled: value }, this);
    }
    get alertsEnabled() {
        return this._alertsEnabled;
    }
    set lastActive(value) {
        console.error('Do not set objects this way');
    }
    setLastActive(value) {
        return this.dataService.updateOrganisationMember(this.id, { last_active: value }, this);
    }
    get lastActive() {
        return this._lastActive;
    }
    set mfaEnabled(value) {
        console.error('Do not set objects this way');
    }
    setMfaEnabled(value) {
        return this.dataService.updateOrganisationMember(this.id, { mfa_enabled: value }, this);
    }
    get mfaEnabled() {
        return this._mfaEnabled;
    }
    set orgOverridePerms(value) {
        console.error('Do not set objects this way');
    }
    setOrgOverridePerms(value) {
        return this.dataService.updateOrganisationMember(this.id, { org_override_perms: value }, this);
    }
    get orgOverridePerms() {
        return this._orgOverridePerms;
    }
    set sitesLimitedTo(value) {
        console.error('Do not set objects this way');
    }
    setSitesLimitedTo(value) {
        return this.dataService.updateOrganisationMember(this.id, { sites_limited_to: (0, util_1.snakeArray)(value) }, this);
    }
    get sitesLimitedTo() {
        return this._sitesLimitedTo;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateOrganisationMember(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteOrganisationMember(this.id, this);
    }
    createLogout(object) {
        return this.dataService.apiService.createOrganisationMemberLogout(this.id, object);
    }
}
exports.default = OrganisationMember;
//# sourceMappingURL=organisationMember.js.map